import { render, staticRenderFns } from "./TicketDetailRoute.vue?vue&type=template&id=72399170"
import script from "./TicketDetailRoute.vue?vue&type=script&lang=js"
export * from "./TicketDetailRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports